module.exports = __webpack_public_path__ + "img/nanshabinghaishidi.46ddec36.png";